import { api } from "@/APIRequests";
import type { PatientFile } from "@/features/patient/types/PatientFile";

export async function getPatientFiles(patientId: string): Promise<PatientFile[]> {
  return api.sharedTyped.get_files({
    data: { entity_id: patientId, entity_type: "patient" },
  });
}
